export default __webpack_public_path__ + "static/media/casaduana_BrendaAngeles.6cd5039e.png";